import { createSelector } from 'reselect';
import { makeSelectSurveyCompleted } from 'containers/Survey/selectors';
import { get } from 'lodash';
import { getValidationErrors } from './utils';
import { SURVEY_END_PAGE_PRODEGE, VARIABLES } from './constants';

/**
 * Direct selector to the linkSettings state domain
 */
const defaultSettings = {};
const selectLinkSettingsDomain = (state) =>
  get(state, 'linkSettings', defaultSettings);

/**
 * Other specific selectors
 */

/**
 * Default selector used by LinkSettings
 */

const makeSelectLinkSettings = createSelector(
  selectLinkSettingsDomain,
  (substate) => substate,
);

const makeSelectIsSaving = createSelector(
  selectLinkSettingsDomain,
  (substate) => get(substate, 'isSaving', false),
);

const makeSelectLinkSettingsErrors = createSelector(
  selectLinkSettingsDomain,
  makeSelectSurveyCompleted,
  (substate, completed = 0) => getValidationErrors(substate, completed),
);

const makeSelectHasLinkValidationErrors = createSelector(
  makeSelectLinkSettingsErrors,
  (validationsErrors = {}) =>
    Object.keys(validationsErrors).some((key) =>
      Boolean(validationsErrors[key]),
    ),
);

const makeLinkSettingsHasPendingChanges = createSelector(
  makeSelectLinkSettings,
  (linkSettings) => {
    const lastSuccessfulEditVersion = get(
      linkSettings,
      'lastSuccessfulEditVersion',
      0,
    );
    const linkSettingsEditVersion = get(
      linkSettings,
      'linkSettingsEditVersion',
      0,
    );
    return lastSuccessfulEditVersion < linkSettingsEditVersion;
  },
);

const makeSelectLinkSettingsEndPageProdegePanel = createSelector(
  selectLinkSettingsDomain,
  (substate) =>
    get(substate, VARIABLES.SURVEY_END_PAGE) === SURVEY_END_PAGE_PRODEGE,
);

export default makeSelectLinkSettings;
export {
  selectLinkSettingsDomain,
  makeSelectIsSaving,
  makeSelectLinkSettingsErrors,
  makeSelectHasLinkValidationErrors,
  makeLinkSettingsHasPendingChanges,
  makeSelectLinkSettingsEndPageProdegePanel,
};
